const state = {
  qtyObj: {
    home: 1,
    // '/flo': 1,
    myredo: 1,
    mystart: 1
  }
}
const mutations = {
  SET_QTY: (state, payload) => {
    // for (let key in payload) {
    //   state.qtyObj[key] = payload[key]
    // }
    for (let index = 0; index < payload.length; index++) {
      const element = payload[index]
      if (state.qtyObj[element.label] !== undefined) {
        state.qtyObj[element.label] = element.value
      }
    }

    // payload.map(
    //   d =>(
    //     state.qtyObj[d.name] !== undefined && (state.qtyObj[d.name] = d.value)
    //   )
    // )
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
